/**
 * Created by Administrador on 06/05/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('productionService',passengerListService);

    passengerListService.$inject = ['$http', 'CONFIG','messageService'];

    function passengerListService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/accountancy';

        var service = {
            getProductionDetailByFlight: getProductionDetailByFlight,
            getProductionTotalByFlight: getProductionTotalByFlight,
            getFlownPerformance: getFlownPerformance,
            getNotFlown: getNotFlown
        };

        return service;

        function getProductionDetailByFlight(departureFlightIds){
            return $http.get(urlBase + '/productionDetailByFlight?' + departureFlightIds)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getProductionTotalByFlight(fromDate, toDate){
            return $http.get(urlBase + '/productionTotalByFlight?fromDate=' + fromDate + '&toDate='+toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getFlownPerformance(fromDate, toDate){
            return $http.get(urlBase + '/flown-performance?fromDate=' + fromDate + '&toDate='+toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getNotFlown(soldDate, toDate){
            return $http.get(urlBase + '/not-flown?soldDate=' + soldDate + '&toDate='+toDate )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
